import React, { useCallback, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { SUPPORTED_WALLETS } from '../../constants/wallet'
import { useActiveWeb3React } from '../../hooks/web3'
import { clearAllTransactions } from '../../state/transactions/actions'
import { shortenAddress, shortenAddress2 } from '../../utils'
import { ExplorerDataType, getExplorerLink } from '../../utils/getExplorerLink'
import { AutoRow } from '../Row'
import Copy from './Copy'
import Transaction from './Transaction'

import { ReactComponent as Close } from '../../assets/images/x.svg'
import { injected, walletconnect, walletlink, fortmatic, portis } from '../../connectors'
import CoinbaseWalletIcon from '../../assets/images/coinbaseWalletIcon.svg'
import WalletConnectIcon from '../../assets/images/walletConnectIcon.svg'
import FortmaticIcon from '../../assets/images/fortmaticIcon.png'
import PortisIcon from '../../assets/images/portisIcon.png'
import Identicon from '../Identicon'
import { ButtonSecondary } from '../Button'
import { ExternalLink as LinkIcon } from 'react-feather'
import { ExternalLink, LinkStyledButton, TYPE } from '../../theme'
import { Trans } from '@lingui/macro'
import { useAppDispatch } from 'state/hooks'
//import getNami from '../../pages/SwapInfo/getNami'

const HeaderRow = styled.div`
  ${({ theme }) => theme.flexRowNoWrap};
  padding: 1rem 1rem;
  font-weight: 500;
  color: ${(props) => (props.color === 'blue' ? ({ theme }) => theme.primary1 : 'inherit')};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem;
  `};
`

const UpperSection = styled.div`
  position: relative;

  h5 {
    margin: 0;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 400;
  }

  h5:last-child {
    margin-bottom: 0px;
  }

  h4 {
    margin-top: 0;
    font-weight: 500;
  }
`

const InfoCard = styled.div`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 20px;
  position: relative;
  display: grid;
  grid-row-gap: 12px;
  margin-bottom: 20px;
`

const AccountGroupingRow = styled.div`
  ${({ theme }) => theme.flexRowNoWrap};
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  color: ${({ theme }) => theme.text1};

  div {
    ${({ theme }) => theme.flexRowNoWrap}
    align-items: center;
  }
`

const AccountSection = styled.div`
  padding: 0rem 1rem;
  ${({ theme }) => theme.mediaWidth.upToMedium`padding: 0rem 1rem 1.5rem 1rem;`};
`

const YourAccount = styled.div`
  h5 {
    margin: 0 0 1rem 0;
    font-weight: 400;
  }

  h4 {
    margin: 0;
    font-weight: 500;
  }
`

const LowerSection = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  padding: 1.5rem;
  flex-grow: 1;
  overflow: auto;
  background-color: ${({ theme }) => theme.bg2};
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  h5 {
    margin: 0;
    font-weight: 400;
    color: ${({ theme }) => theme.text3};
  }
`

const AccountControl = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 0;
  width: 100%;

  font-weight: 500;
  font-size: 1.25rem;

  a:hover {
    text-decoration: underline;
  }

  p {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const AddressLink = styled(ExternalLink)<{ hasENS: boolean; isENS: boolean }>`
  font-size: 0.825rem;
  color: ${({ theme }) => theme.text3};
  margin-left: 1rem;
  font-size: 0.825rem;
  display: flex;
  :hover {
    color: ${({ theme }) => theme.text2};
  }
`

const CloseIcon = styled.div`
  position: absolute;
  right: 1rem;
  top: 14px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

const CloseColor = styled(Close)`
  path {
    stroke: ${({ theme }) => theme.text4};
  }
`

const WalletName = styled.div`
  width: initial;
  font-size: 0.825rem;
  font-weight: 500;
  color: ${({ theme }) => theme.text3};
`

const Img = styled.img`
  width: 30px;
  height: 30px;
`

const Span = styled.div`
  display: inline-block !important;
  height: 30px;
  line-height: 30px;
  vertical-align: top;
  margin-left: 25px;
  width: 150px;
  text-align: left;

`

const IconWrapper = styled.div<{ size?: number }>`
  ${({ theme }) => theme.flexColumnNoWrap};
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  & > img,
  span {
    height: ${({ size }) => (size ? size + 'px' : '32px')};
    width: ${({ size }) => (size ? size + 'px' : '32px')};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: flex-end;
  `};
`

const TransactionListWrapper = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap};
`

const WalletAction = styled(ButtonSecondary)`
  width: fit-content;
  font-weight: 400;
  margin-left: 8px;
  font-size: 0.825rem;
  padding: 4px 6px;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

const WalletConnect = styled(WalletAction)`
  font-size: 0.825rem;
  font-weight: 400; 
  margin-right: 8px;
  width: 300px; 
  height: 40px;
  display: inline-block;
  flex: auto;
`

const MainWalletAction = styled(WalletAction)`
  color: ${({ theme }) => theme.primary1};
`

const NamiPanel = (state: any)=> {
  
  
  if (window.cardano == null) {
    return (
      <>
        <AccountGroupingRow>
            <WalletName>
            <Trans>Please install the Nami, CCVault or Yoroi to use Cardano bridge</Trans>
          </WalletName>
        </AccountGroupingRow>
      </>
      )
  }

  const isEnabled = window.cardano[state.data.nami.type] != null && state.data.nami.isEnabled;
  
  const disconnectWallet = async()=> {
    localStorage.removeItem("cardanoWallet")
    location.reload()
  } 

  const connectWallet = (type)=> async ()=> {
    //const nami = await getNami(state);
    if (window.cardano == null)
      return
    const result = await window.cardano[type].enable()
    if (result) {
      localStorage.setItem("cardanoWallet", type) 
      location.reload();
    }
    
  }

  if (isEnabled == false) {
    return (
      <>
        <AccountGroupingRow>
          <WalletName>
            <Trans>Cardano Wallet is not connected</Trans>
          </WalletName>
        </AccountGroupingRow>
        { window.cardano.nami == null ? null : (
            <AccountGroupingRow>
                  <WalletConnect
                              onClick={connectWallet("nami")}
                            >
                              <Img src={window.cardano.nami.icon} />
                              <Span>Connect Nami</Span>
                  </WalletConnect>
                
              </AccountGroupingRow>
          )}
          { window.cardano.ccvault == null ? null : (
          <AccountGroupingRow>
          <WalletConnect
                      onClick={connectWallet("ccvault")}
                    >
                      <Img src={window.cardano.ccvault.icon} />
                      <Span>Connect CCVault</Span>
          </WalletConnect>
          </AccountGroupingRow>
          )}
          { window.cardano.yoroi == null ? null : (
          <AccountGroupingRow>
          <WalletConnect
                      onClick={connectWallet("yoroi")}
                    >
                      <Img src="data:image/png;base64,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" />
                      <Span>Connect Yoroi</Span>
           
          </WalletConnect>
          </AccountGroupingRow>
        )}
      </>
      )
  }

  return (
  <>
    <AccountGroupingRow>
      <WalletName>
          <Trans>Connected with {state.data.nami.type.toUpperCase()} Wallet</Trans>
      </WalletName>
    </AccountGroupingRow>
    <AccountGroupingRow>
      <AccountControl>
        <div>
            <div>{shortenAddress2(state.data.nami.account)}</div>
            <Copy toCopy={state.data.nami.account}>
              <span style={{ marginLeft: '4px' }}>
                <Trans>Copy Address</Trans>
              </span>
            </Copy>
            <WalletAction
                      style={{ fontSize: '.825rem', fontWeight: 400, marginRight: '8px' }}
                      onClick={disconnectWallet}
                    >
                      <Trans>Disconnect</Trans>
            </WalletAction>
        </div>
      </AccountControl>
    </AccountGroupingRow>
  </>
  )
}

function renderTransactions(transactions: string[]) {
  return (
    <TransactionListWrapper>
      {transactions.map((hash, i) => {
        return <Transaction key={i} hash={hash} />
      })}
    </TransactionListWrapper>
  )
}

interface AccountDetailsProps {
  state: any
  toggleWalletModal: () => void
  pendingTransactions: string[]
  confirmedTransactions: string[]
  ENSName?: string
  openOptions: () => void
}

export default function AccountDetails({
  toggleWalletModal,
  pendingTransactions,
  confirmedTransactions,
  ENSName,
  state,
  openOptions,
}: AccountDetailsProps) {
  const { chainId, account, connector } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const dispatch = useAppDispatch()

  function formatConnectorName() {
    const { ethereum } = window
    const isMetaMask = !!(ethereum && ethereum.isMetaMask)
    const name = Object.keys(SUPPORTED_WALLETS)
      .filter(
        (k) =>
          SUPPORTED_WALLETS[k].connector === connector && (connector !== injected || isMetaMask === (k === 'METAMASK'))
      )
      .map((k) => SUPPORTED_WALLETS[k].name)[0]
    return (
      <WalletName>
        <Trans>Connected with {name}</Trans>
      </WalletName>
    )
  }

  function getStatusIcon() {
    if (connector === injected) {
      return (
        <IconWrapper size={16}>
          <Identicon />
        </IconWrapper>
      )
    } else if (connector === walletconnect) {
      return (
        <IconWrapper size={16}>
          <img src={WalletConnectIcon} alt={'WalletConnect logo'} />
        </IconWrapper>
      )
    } else if (connector === walletlink) {
      return (
        <IconWrapper size={16}>
          <img src={CoinbaseWalletIcon} alt={'Coinbase Wallet logo'} />
        </IconWrapper>
      )
    } else if (connector === fortmatic) {
      return (
        <IconWrapper size={16}>
          <img src={FortmaticIcon} alt={'Fortmatic logo'} />
        </IconWrapper>
      )
    } else if (connector === portis) {
      return (
        <>
          <IconWrapper size={16}>
            <img src={PortisIcon} alt={'Portis logo'} />
            <MainWalletAction
              onClick={() => {
                portis.portis.showPortis()
              }}
            >
              <Trans>Show Portis</Trans>
            </MainWalletAction>
          </IconWrapper>
        </>
      )
    }
    return null
  }

  const clearAllTransactionsCallback = useCallback(() => {
    if (chainId) dispatch(clearAllTransactions({ chainId }))
  }, [dispatch, chainId])

  

  return (
    <>
      <UpperSection>
        <CloseIcon onClick={toggleWalletModal}>
          <CloseColor />
        </CloseIcon>
        <HeaderRow>
          <Trans>Account</Trans>
        </HeaderRow>
        <AccountSection>
          <YourAccount>
            <InfoCard>
              <AccountGroupingRow>
                {formatConnectorName()}
                <div>
                  {connector !== injected && connector !== walletlink && (
                    <WalletAction
                      style={{ fontSize: '.825rem', fontWeight: 400, marginRight: '8px' }}
                      onClick={() => {
                        ;(connector as any).close()
                      }}
                    >
                      <Trans>Disconnect</Trans>
                    </WalletAction>
                  )}
                  <WalletAction
                    style={{ fontSize: '.825rem', fontWeight: 400 }}
                    onClick={() => {
                      openOptions()
                    }}
                  >
                    <Trans>Change</Trans>
                  </WalletAction>
                </div>
              </AccountGroupingRow>
              <AccountGroupingRow id="web3-account-identifier-row">
                <AccountControl>
                  {ENSName ? (
                    <>
                      <div>
                        {getStatusIcon()}
                        <p> {ENSName}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        {getStatusIcon()}
                        <p> {account && shortenAddress(account)}</p>
                      </div>
                    </>
                  )}
                </AccountControl>
              </AccountGroupingRow>
              <AccountGroupingRow>
                {ENSName ? (
                  <>
                    <AccountControl>
                      <div>
                        {account && (
                          <Copy toCopy={account}>
                            <span style={{ marginLeft: '4px' }}>
                              <Trans>Copy Address</Trans>
                            </span>
                          </Copy>
                        )}
                        {chainId && account && (
                          <AddressLink
                            hasENS={!!ENSName}
                            isENS={true}
                            href={getExplorerLink(chainId, ENSName, ExplorerDataType.ADDRESS)}
                          >
                            <LinkIcon size={16} />
                            <span style={{ marginLeft: '4px' }}>
                              <Trans>View on Explorer</Trans>
                            </span>
                          </AddressLink>
                        )}
                      </div>
                    </AccountControl>
                  </>
                ) : (
                  <>
                    <AccountControl>
                      <div>
                        {account && (
                          <Copy toCopy={account}>
                            <span style={{ marginLeft: '4px' }}>
                              <Trans>Copy Address</Trans>
                            </span>
                          </Copy>
                        )}
                        {chainId && account && (
                          <AddressLink
                            hasENS={!!ENSName}
                            isENS={false}
                            href={getExplorerLink(chainId, account, ExplorerDataType.ADDRESS)}
                          >
                            <LinkIcon size={16} />
                            <span style={{ marginLeft: '4px' }}>
                              <Trans>View on Explorer</Trans>
                            </span>
                          </AddressLink>
                        )}
                      </div>
                    </AccountControl>
                  </>
                )}
              </AccountGroupingRow>
            </InfoCard>
            <InfoCard>
              {NamiPanel(state)}
            </InfoCard>
          </YourAccount>
        </AccountSection>
      </UpperSection>
      {!!pendingTransactions.length || !!confirmedTransactions.length ? (
        <LowerSection>
          <AutoRow mb={'1rem'} style={{ justifyContent: 'space-between' }}>
            <TYPE.body>
              <Trans>Recent Transactions</Trans>
            </TYPE.body>
            <LinkStyledButton onClick={clearAllTransactionsCallback}>
              <Trans>(clear all)</Trans>
            </LinkStyledButton>
          </AutoRow>
          {renderTransactions(pendingTransactions)}
          {renderTransactions(confirmedTransactions)}
        </LowerSection>
      ) : null}
    </>
  )
}
